
const countSelectedFilters = (filtersSelected) => Object.values(filtersSelected).reduce((acc, curr) => acc + curr.length,0);

const countNestedSelectedFilters = (filtersSelected) => {
  return Object.values(filtersSelected).reduce((total, section) => {
    return total + Object.values(section).reduce((subTotal, arr) => {
      return subTotal + (Array.isArray(arr) ? arr.length : 0);
    }, 0);
  }, 0);
};

export { countSelectedFilters, countNestedSelectedFilters };
